import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { formatGearBadge, type GearItem } from "@/lib/teamMembers";

// Gear pills use the brand accent (green, --primary) in a tinted style
// rather than the bright solid lime, so a row full of them stays
// readable. One component so the table and the bulk-add preview render
// gear identically.
export const GEAR_PILL_CLASS = "border-primary/30 bg-primary/15 text-primary hover:bg-primary/20";

interface GearBadgeProps {
  gear: GearItem;
  className?: string;
}

export const GearBadge = ({ gear, className }: GearBadgeProps) => (
  <Badge variant="outline" className={cn("text-xs font-medium", GEAR_PILL_CLASS, className)}>
    {formatGearBadge(gear)}
  </Badge>
);

export default GearBadge;
